import { jsx as _jsx } from "react/jsx-runtime";
import { StyledCTA } from './styled';
export const HeroButton = ({ to, large, onClick, children }) => (_jsx(StyledCTA, { buttonTheme: "upgrade", large: large, to: to, onClick: onClick, children: children }));
